import { Alert, AlertTitle, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { AppNotification } from '@/types/notifications'
import { safeInternalNotificationUrl } from './notificationPresentation'

interface NotificationToastItemProps {
  notification: AppNotification
  onClose: () => void
  onOpen: () => void
}

export function NotificationToastItem({
  notification,
  onClose,
  onOpen,
}: NotificationToastItemProps) {
  const { t } = useTranslation()
  const hasTarget = Boolean(safeInternalNotificationUrl(notification.url))
  return (
    <Alert
      severity="info"
      variant="filled"
      onClose={onClose}
      sx={{ width: 360, maxWidth: 'calc(100vw - 32px)', boxShadow: 6 }}
      action={
        hasTarget ? (
          <Button color="inherit" size="small" onClick={onOpen}>
            {t('common.view')}
          </Button>
        ) : undefined
      }
    >
      <AlertTitle>{notification.title}</AlertTitle>
      {notification.body}
    </Alert>
  )
}
